module.exports = __webpack_public_path__ + "img/funnel-nec-2021.8d140641.svg";